import React from "react";
import "./Description.scss";

export default function Description({
    children,
    className = '',
    ...rest
}) {
    return (
        <div className={`description ${className}`} {...rest}>
            {children}
        </div>
    );
}
